import { findUrl } from '@dishly/shared';

/** Reads a link from the clipboard (call from a tap; iOS asks with a Paste button). */
export async function clipboardLink(): Promise<string | null> {
  try {
    const text = await navigator.clipboard.readText();
    return findUrl(text);
  } catch {
    return null;
  }
}

/**
 * Whether the clipboard can be read without the browser asking. Only a granted
 * `clipboard-read` permission counts: Safari (iOS) doesn't know the permission and shows
 * its Paste callout on every read, so the sheet must not read it unasked there.
 */
export async function clipboardReadable(): Promise<boolean> {
  try {
    const status = await navigator.permissions.query({ name: 'clipboard-read' as PermissionName });
    return status.state === 'granted';
  } catch {
    return false;
  }
}

/** Whether a paste button can work (the Clipboard API exists only in secure contexts). */
export const canReadClipboard = () => typeof navigator !== 'undefined' && 'clipboard' in navigator;
